import React from 'react';
import { Link } from 'react-router-dom';

const MenuItems = (props) => {
    // const { parentMenu, secondParentMenu, activeMenu } = props;
    const { parentMenu,  activeMenu } = props;

    return (
        <React.Fragment>
            <li className={parentMenu === 'Home' ? '' : ''}>
                <Link to="/">Home</Link>
                {/* <ul className="sub-menu"> */}
                    {/* <li>
                        <Link to="/" className={activeMenu === "/home-1"  ? "active-menu" : ""}>Home One</Link>
                    </li> */}
                    {/* <li>
                        <Link to="/home-2" className={activeMenu === "/home-2" ? "active-menu" : ""}>Home Two</Link>
                    </li> */}

                    {/* <li className={secondParentMenu === 'Home' ? 'dropdown current-menu-item' : 'dropdown'}>
                        <Link to="#">Header Style</Link>
                        <ul className="sub-menu right ">
                            <li>
                                <Link to="/" className={activeMenu === "/" ? "active-menu" : ""}>Header One</Link>
                            </li>
                            <li>
                                <Link to="/home-2" className={activeMenu === "/home-2" ? "active-menu" : ""}>Header Two</Link>
                            </li>
                        </ul>
                    </li> */}
                {/* </ul> */}
            </li>
            <li className={parentMenu === 'about' ? 'current-menu-item' : ''}>
                <Link to="/about" className={activeMenu === "/about" ? "active-menu" : ""}>About</Link>
            </li>
            <li className={parentMenu === 'page' ? 'current-menu-item' : ''}>
                <Link to="/services" className={activeMenu === "/services" ? "active-menu" : ""}>Pages</Link>
            </li>
            <li className={parentMenu === 'Services' ? 'current-menu-item' : ''}>
                <Link to="/services" className={activeMenu === "/services" ? "active-menu" : ""}>Services</Link>
            </li>
            <li className={parentMenu === 'Project' ? 'current-menu-item' : ''}>
                <Link to="/project" className={activeMenu === "/project" ? "active-menu" : ""}>Projects</Link>
            </li>
            {/* <li className={parentMenu === 'blog' ? 'dropdown current-menu-item' : 'dropdown'}>
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                    <li>
                        <Link to="/blog" className={activeMenu === "/blog" ? "active-menu" : ""}>Blog</Link>
                    </li>
                    <li>
                        <Link to="/blog-details" className={activeMenu === "/blog-details" ? "active-menu" : ""}>Blog details</Link>
                    </li>
                </ul>
            </li> */}
            <li className={parentMenu === 'contact' ? 'current-menu-item' : ''}>
                <Link to="/contact" className={activeMenu === "/contact" ? "active-menu" : ""}>Contact</Link>
            </li>
            
        </React.Fragment>
    );
}

export default MenuItems;